export const PRE_PURCHASE_CHECKOUT_PARAM = 'prePurchaseUpsellCheckoutPage';

export const IS_FROM_CONSUMER_XDP_PARAM = 'isFromDescriptionPage';

export const IS_FROM_PRE_PURCHASE_UPSELL_PARAM = 'isFromPrePurchaseUpsell';

export const GOOGLE_PARTNER_IDS = ['443', '463', '481'];

export const isPrePurchaseUpsellCheckoutPageShown = (query: Record<string, string>) => {
  if (query[PRE_PURCHASE_CHECKOUT_PARAM] === 'true') {
    return true;
  }

  return false;
};

// This function determines whether we should show checkout changes for Elevate LTV:
// - the redesigned post-purchase upsell (if applicable) for Variant 2 and 3
// - the redesigned checkout page for Variant 3
// This returns true for all content excluding Google, which checks for the learner coming from Consumer XDP
export const shouldShowCheckoutChangesForElevateLTV = ({
  params,
  partnerId,
}: {
  params?: Record<string, string>;
  partnerId?: string;
}) => {
  // Only show post-purchase upsell for Google content if learner came from Consumer XDP,
  // not the Google-owned XDP or the paid media XDP
  if (params && partnerId && GOOGLE_PARTNER_IDS.includes(partnerId)) {
    return Boolean(params[IS_FROM_CONSUMER_XDP_PARAM]);
  }

  return true;
};
